import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    clientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    eventextra1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    eventextra2: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    eventextra5: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    reference: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    }
  },
  layout: {
      rows: [
          {
              fields: [
                  {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name: (If applicable)',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email',
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telnumber',
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
                size: 'Medium',
                label: 'Types of Services Needed:*',
                options: [
                  { label: 'Catering and Bar', value: 'Catering and Bar' },
                  { label: 'Catering Only', value: 'Catering Only' },
                  { label: 'Bar Only', value: 'Bar Only' },
                  { label: 'Drop-Off Catering', value: 'Drop-Off Catering' },
                  { label: 'Staffing Only', value: 'Staffing Only' },
                ],
                mapping: 'eventextra2',
              }
            ]
          },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Nature of Event:*',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Rehearsal', value: 'Rehearsal' },
              { label: 'Private Event', value: 'Private Event' },
              { label: 'Corporate', value: 'Corporate' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Other (use details section)', value: 'Other (use details section)' },
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event Start Time:',
        options: [
          { label: '6:00AM'  , value: '06:00:00'},
          { label: '6:30AM'  , value: '06:30:00'},
          { label: '7:00AM'  , value: '07:00:00'},
          { label: '7:30AM'  , value: '07:30:00'},
          { label: '8:00AM'  , value: '08:00:00'},
          { label: '8:30AM'  , value: '08:30:00'},
          { label: '9:00AM'  , value: '09:00:00'},
          { label: '9:30AM'  , value: '09:30:00'},
          { label: '10:00AM' , value: '10:00:00'},
          { label: '10:30AM' , value: '10:30:00'},
          { label: '11:00AM' , value: '11:00:00'},
          { label: '11:30AM' , value: '11:30:00'},
          { label: '12:00PM' , value: '12:00:00'},
          { label: '12:30PM' , value: '12:30:00'},
          { label: '1:00PM'  , value: '13:00:00'},
          { label: '1:30PM'  , value: '13:30:00'},
          { label: '2:00PM'  , value: '14:00:00'},
          { label: '2:30PM'  , value: '14:30:00'},
          { label: '3:00PM'  , value: '15:00:00'},
          { label: '3:30PM'  , value: '15:30:00'},
          { label: '4:00PM'  , value: '16:00:00'},
          { label: '4:30PM'  , value: '16:30:00'},
          { label: '5:00PM'  , value: '17:00:00'},
          { label: '5:30PM'  , value: '17:30:00'},
          { label: '6:00PM'  , value: '18:00:00'},
          { label: '6:30PM'  , value: '18:30:00'},
          { label: '7:00PM'  , value: '19:00:00'},
          { label: '7:30PM'  , value: '19:30:00'},
          { label: '8:00PM'  , value: '20:00:00'},
          { label: '8:30PM'  , value: '20:30:00'},
          { label: '9:00PM'  , value: '21:00:00'},
          { label: '9:30PM'  , value: '21:30:00'},
          { label: '10:00PM' , value: '22:00:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '12:00 AM (next day)', value: '00:00:00' },
        ],
        mapping: 'starttime',
      }
    ]
  },
  {
    fields: [
      {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event End Time:',
        options: [
          { label: '6:00AM'  , value: '06:00:00'},
          { label: '6:30AM'  , value: '06:30:00'},
          { label: '7:00AM'  , value: '07:00:00'},
          { label: '7:30AM'  , value: '07:30:00'},
          { label: '8:00AM'  , value: '08:00:00'},
          { label: '8:30AM'  , value: '08:30:00'},
          { label: '9:00AM'  , value: '09:00:00'},
          { label: '9:30AM'  , value: '09:30:00'},
          { label: '10:00AM' , value: '10:00:00'},
          { label: '10:30AM' , value: '10:30:00'},
          { label: '11:00AM' , value: '11:00:00'},
          { label: '11:30AM' , value: '11:30:00'},
          { label: '12:00PM' , value: '12:00:00'},
          { label: '12:30PM' , value: '12:30:00'},
          { label: '1:00PM'  , value: '13:00:00'},
          { label: '1:30PM'  , value: '13:30:00'},
          { label: '2:00PM'  , value: '14:00:00'},
          { label: '2:30PM'  , value: '14:30:00'},
          { label: '3:00PM'  , value: '15:00:00'},
          { label: '3:30PM'  , value: '15:30:00'},
          { label: '4:00PM'  , value: '16:00:00'},
          { label: '4:30PM'  , value: '16:30:00'},
          { label: '5:00PM'  , value: '17:00:00'},
          { label: '5:30PM'  , value: '17:30:00'},
          { label: '6:00PM'  , value: '18:00:00'},
          { label: '6:30PM'  , value: '18:30:00'},
          { label: '7:00PM'  , value: '19:00:00'},
          { label: '7:30PM'  , value: '19:30:00'},
          { label: '8:00PM'  , value: '20:00:00'},
          { label: '8:30PM'  , value: '20:30:00'},
          { label: '9:00PM'  , value: '21:00:00'},
          { label: '9:30PM'  , value: '21:30:00'},
          { label: '10:00PM' , value: '22:00:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '12:00 AM (next day)', value: '00:00:00' },
        ],
        mapping: 'endtime'
      }
    ]
  },
  {
    fields: [
      {
        type: 'text',
        size: 'Medium',
        label: 'Estimated Number of Guests:',
        mapping: 'plannedguestcount',
      }
    ]
  },
  {
    fields: [
      {
        type: 'multiple-choice',
            size: 'Medium',
            label: 'Budget:*',
            options: [
              {label: '$0-$5000' , value: '$0-$5000'},
              {label: '$5000-$10,000' , value: '$5000-$10,000'},
              {label: '$10,000-$15,000' , value: '$10,000-$15,000'},
              {label: '$15,000-$20,000' , value: '$15,000-$20,000'},
              {label: '$20,000-$25,000' , value: '$20,000-$25,000'},
              {label: '$25,000+' , value: '$25,000+'},
            ],
            mapping: 'eventextra1',
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
                size: 'Medium',
                label: 'Are you working with a planner?:*',
                options: [
                  { label: 'Yes', value: 'Yes' },
                  { label: 'No', value: 'No' },
                ],
                mapping: 'eventextra5',
              }
            ]
          },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'How Did You Hear About Us?:',
        options: [
          { label: 'Instagram', value: 'Instagram' },
          { label: 'Facebook', value: 'Facebook' },
          { label: 'The Knot/WeddingWire', value: 'The Knot/WeddingWire' },
          { label: 'Search Engine', value: 'Search Engine' },
          { label: 'Event Planner', value: 'Event Planner' },
          { label: 'Venue', value: 'Venue' },
          { label: 'Google Ad', value: 'Google Ad' },
          { label: 'Returning Customer', value: 'Returning Customer' },
          { label: 'Attended R&R Event', value: 'Attended R&R Event' },
          { label: 'Referral', value: 'Referral' },
          { label: 'Other', value: 'Other' },
        ],
        mapping: 'reference'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:*',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Rosemary & Rye Catering Inquiry Form',
    formId: '1956',
    clientKey: '60B5D48E-669E-47CB-98D3-6CCAA08457DF',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://rosemaryandrye.com/thank-you/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
